
import CalendarNavigation from './CalendarNavigation';

interface CalendarHeaderProps {
  title: string;
  subtext: string;
  currentDate: Date;
  setCurrentDate: (date: Date) => void;
  checkInDate?: Date;
  checkOutDate?: Date;
  onClearDates?: () => void;
  isMobile: boolean;
}

const CalendarHeader = ({ 
  title, 
  subtext, 
  currentDate, 
  setCurrentDate, 
  checkInDate, 
  checkOutDate, 
  onClearDates, 
  isMobile 
}: CalendarHeaderProps) => {
  return (
    <>
      <div className="flex items-center justify-between mb-2" data-calendar-title id="calendar-title">
        <h3 className="text-xl font-semibold">{title}</h3>
        
        <CalendarNavigation
          currentDate={currentDate}
          setCurrentDate={setCurrentDate}
          checkInDate={checkInDate}
          checkOutDate={checkOutDate}
          onClearDates={onClearDates}
          isMobile={isMobile}
        />
      </div>

      <div className="mb-6">
        <p className={`${checkInDate && checkOutDate ? 'text-blue-600' : 'text-gray-600'}`}>
          {subtext}
        </p>
      </div>
    </>
  );
};

export default CalendarHeader;
